/*
const myPath = new StarTextPath({
  x: 50,
  y: 50,
  fill: 'black',
  fontSize: 24,
  fontFamily: 'Arial',
  text: 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
  width: 250,
  height: 250,
  points: 5,
  radius: 0.5
});
console.log("myPath", myPath);
layer.add(myPath);
layer.draw();
*/
class StarTextPath extends BaseTextPath {
  constructor(config) {
    super(config);

    this.className = 'StarTextPath';
    this.attrs.type = "startextpath";

    this.width(config?.width ?? 300);
    this.height(config?.height ?? 300);
    this.points(config?.points ?? 5);
    this.radius(config?.radius ?? 0.5);
  }


  static getAttrNames() { return ['width', 'height', 'points', 'radius']; }
  static getDefaultAttrs() { return { width: 300, height: 300, points: 5, radius: 0.5 }; }


  width(v) {
    if (v === undefined) return this.attrs.width ?? 0;
    this.attrs.width = v;
    this.updatePath();
    return this;
  }


  height(v) {
    if (v === undefined) return this.attrs.height ?? 0;
    this.attrs.height = v;
    this.updatePath();
    return this;
  }


  points(v) {
    if (v === undefined) return this.attrs.points ?? 0;
    this.attrs.points = v;
    this.updatePath();
    return this;
  }


  radius(v) {
    if (v === undefined) return this.attrs.radius ?? 0;
    console.log("startextpath set radius", v);
    this.attrs.radius = v;
    this.updatePath();
    return this;
  }


  updatePath() {
    this.setData(this.generateSvgPath(this.width(), this.height(), this.points(), this.radius()));
  }


  generateSvgPath(width, height, points=5, innerRadius=0.5) {
    //console.log(width, height, points, innerRadius);
    const centerX = width / 2;
    const centerY = height / 2;
    
    // Radii are based on the full width and height to allow for stretching
    const outerRadiusX = width / 2;
    const outerRadiusY = height / 2;
    
    // Inner radii are a proportional percentage of the outer radii
    const innerRadiusX = outerRadiusX * innerRadius;
    const innerRadiusY = outerRadiusY * innerRadius;
    
    let path = '';
    let start = '';
    
    for (let i = 0; i < points * 2; i++) {
      const angle = (-Math.PI / 2) + (i * (Math.PI / points));
      const radiusX = i % 2 === 0 ? outerRadiusX : innerRadiusX;
      const radiusY = i % 2 === 0 ? outerRadiusY : innerRadiusY;

      // Calculate x and y coordinates using separate radii for proper scaling
      const x = centerX + radiusX * Math.cos(angle);
      const y = centerY + radiusY * Math.sin(angle);

      if (i === 0) {
        path = `M${x},${y}`;
        start = `L${x},${y}`;
      } else {
        path += `L${x},${y}`;
      }
    }
    
    path += start;

    return path + 'Z';
  }

}

